
import { useStore } from "vuex";
import { defineComponent, computed } from "vue";

export default defineComponent({
  setup() {
    //
    const store = useStore();
    const timePerTurn = computed(() => store.getters.getTimePerRound);
    const currentTime = computed(() => store.getters.getCurrentTime);

    const progress = computed(() => {
      return (currentTime.value * 100) / timePerTurn.value + "%";
    });

    return {
      progress,
      currentTime,
    };
  },
});
